// polyfill of passive option
const checkSupportsPassive = () => {
    let supportsPassive = false;
    try {
        const opts = Object.defineProperty({}, 'passive', {
            get() {
                supportsPassive = true;
                return null;
            },
        });
        window.addEventListener('test', () => { }, opts);
        return supportsPassive;
    }
    catch (e) {
        throw e;
    }
};
const supportsPassive = checkSupportsPassive();
export default supportsPassive;
//# sourceMappingURL=supportsPassive.js.map